import { ConvertTypeEnum } from './convert';
import { isFunction, isObject, isString } from './is';
function getConvert(value, convertKey, convert) {
    var _convert;
    if (isFunction(value)) {
        _convert = value;
    }
    else if (isFunction(convertKey)) {
        _convert = convertKey;
    }
    else if (isFunction(convert)) {
        _convert = convert;
    }
    return _convert;
}
function getValue(value) {
    if (isObject(value)) {
        return value;
    }
    return undefined;
}
function getConvertKey(value, convertKey) {
    if (isString(value))
        return value;
    if (isString(convertKey))
        return convertKey;
    return undefined;
}
export function ObjectType(value, convertKey, convert) {
    var _value = getValue(value);
    var _convertKey = getConvertKey(value, convertKey);
    var _convert = getConvert(value, convertKey, convert);
    return {
        type: ConvertTypeEnum.Object,
        convertKey: _convertKey,
        value: _value,
        convert: _convert,
    };
}
export function ArrayType(value, convertKey, convert) {
    var _value = getValue(value);
    var _convertKey = getConvertKey(value, convertKey);
    var _convert = getConvert(value, convertKey, convert);
    return {
        type: ConvertTypeEnum.Array,
        convertKey: _convertKey,
        convert: _convert,
        value: _value,
    };
}
export function StringType(convertKey, convert) {
    var _convertKey = getConvertKey(undefined, convertKey);
    var _convert = getConvert(undefined, convertKey, convert);
    return {
        type: ConvertTypeEnum.String,
        convertKey: _convertKey,
        convert: _convert,
    };
}
export function NumberType(convertKey, convert) {
    var _convertKey = getConvertKey(undefined, convertKey);
    var _convert = getConvert(undefined, convertKey, convert);
    return {
        type: ConvertTypeEnum.Number,
        convertKey: _convertKey,
        convert: _convert,
    };
}
//# sourceMappingURL=data:application/json;base64,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